import api from '../api/';

const searchService = async (images: string[], company: string) => {
  return (await api.post('/search', { company, images })).data;
};

export { searchService };
